import { FORTA_BLUE } from '../../utils/colors';

import type { IconProps } from './types';

const TimeZoneIcon = (props: IconProps) => {
  const { color = FORTA_BLUE.primary, width = 26, height = 24, viewBox = '0 0 26 24' } = props;

  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox={`${viewBox}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="11.5" stroke={color} />
      <path
        d="M18.5 12C18.5 15.2411 17.7326 18.1509 16.5179 20.2333C15.2959 22.3281 13.6813 23.5 12 23.5C10.3187 23.5 8.70406 22.3281 7.48214 20.2333C6.26739 18.1509 5.5 15.2411 5.5 12C5.5 8.7589 6.26739 5.84909 7.48214 3.76665C8.70406 1.67194 10.3187 0.5 12 0.5C13.6813 0.5 15.2959 1.67194 16.5179 3.76665C17.7326 5.84909 18.5 8.7589 18.5 12Z"
        stroke={color}
      />
      <path d="M1 12H23" stroke={color} strokeLinecap="round" />
      <path d="M12 23L12 1" stroke={color} strokeLinecap="round" />
      <circle cx="18.5" cy="16.5" r="7" fill="white" stroke={color} />
      <path
        d="M22.6181 20.3538L18.1916 16.6395C18.0859 16.5508 18.0721 16.3931 18.1608 16.2873L20.0801 14"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default TimeZoneIcon;
